import * as React from 'react'
import {translateCountryName} from "@ui-seeker/utils"

import LabelCountry from "../../LabelCountry";
import {Box} from "@mui/material";


export default function countryColumn() {
	return [{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	}, {
		name: 'country', label: 'Country',
		options: {
			filter: false,
			headerAlign: 'left',
            customBodyRowRenderLite: value =>
                <Box className={value === 'All' ? 'is-all' : ''}>
                    {value !== 'All' ? <LabelCountry
                        country={value}
                        label={translateCountryName(value)}
                    /> : 'All'}
                </Box>
		}
	}]
}